var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"big-data"},[(_vm.homeFlag)?_c('div',[_c('Index'),_c('router-view')],1):_c('div',[_c('Home')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }